import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';

import { LucideAngularModule, Compass, Search, Crown, Sun, BookOpen, Milestone, ShieldAlert, Target, Users, Star, Heart, Coins, ChevronDown, Zap, ArrowRight, Globe, Sparkles, Sparkle, Shield, ChevronUp, Command, Copy, Check, ExternalLink, ShieldCheck, Mail, Phone, MapPin, FileText, Home, Lightbulb, Bug, LayoutGrid, HelpCircle, AlertTriangle, File, Bell, X, RefreshCw, Inbox } from 'lucide-angular';
import { routes } from './app-routing.module';
import { HTTP_INTERCEPTORS, HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { ClipboardModule } from 'ngx-clipboard';
import { ToastrModule } from 'ngx-toastr';
import { AuthInterceptor } from './auth/auth.interceptor';
import { provideDeviceTracking } from './auth/device-tracking.providers';
import { NgxSpinnerModule } from "ngx-spinner";
import { ModalModule } from 'ngx-bootstrap/modal';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { ProgressBarModule } from "angular-progress-bar";
import { environment } from 'src/environments/environment';
import { HttpClientModule, HttpClientJsonpModule } from '@angular/common/http'; // Import HttpClientJsonpModule
import { EnsureSecondsPipe } from './shared/pipes/ensureSeconds.pipe';
import { MatrixPeriodFormatPipePipe } from './shared/pipes/matrix-period-format-pipe.pipe';
import { HighlightInitiativeColorPipe } from './shared/pipes/highlight-initiative-color.pipe';
import { ColorCodePipe } from './shared/pipes/color-code.pipe';

export function HttpLoaderFactory(httpClient: HttpClient) {
  const suffix = environment.production ? '.json' : `.json?v=${Date.now()}`;
  return new TranslateHttpLoader(httpClient, environment.LANGUAGES_FILE_PATH, suffix);
}
export const appConfig: ApplicationConfig = {
  providers: [

    importProvidersFrom(
      ProgressBarModule,
      BrowserModule,
      NgxSpinnerModule,
      HttpClientModule,
      HttpClientJsonpModule,
      ClipboardModule, ModalModule.forRoot(),
      ToastrModule.forRoot({
        // 2 000 ms was not long enough to read a validation message, and on mobile part of it was
        // spent off-screen while the keyboard was opening (troubleshooting.md — the POST-SAF-AOC
        // public-key toast). This is app-wide: every toast now stays up for 4 s.
        timeOut: 4000,
        preventDuplicates: true,
        maxOpened: 1,
      }),
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: httpTranslateLoader,
          deps: [HttpClient]
        }
      }),
      LucideAngularModule.pick({ Compass, Search, Crown, Sun, BookOpen, Milestone, ShieldAlert, Target, Users, Star, Heart, Coins, ChevronDown, Zap, ArrowRight, Globe, Sparkles, Sparkle, Shield, ChevronUp, Home, Lightbulb, FileText, Bug, LayoutGrid, HelpCircle, AlertTriangle, File, Command, Copy, Check, ExternalLink, ShieldCheck, Mail, Phone, MapPin, Bell, X, RefreshCw, Inbox })

    ),
    provideRouter(routes, withComponentInputBinding()),
    provideHttpClient(
      withInterceptorsFromDi(),
    ),
    provideAnimations(),
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    provideDeviceTracking(),
    EnsureSecondsPipe,
    MatrixPeriodFormatPipePipe,
    HighlightInitiativeColorPipe,
    ColorCodePipe
  ]
};

// AOT compilation support
export function httpTranslateLoader(http: HttpClient) {
  // Add a cache buster in dev so changes in `assets/i18n/*.json` reflect immediately without hard refresh.
  const suffix = environment.production ? '.json' : `.json?v=${Date.now()}`;
  return new TranslateHttpLoader(http, environment.LANGUAGES_FILE_PATH, suffix);
}
